import { getSevColor } from '@/constants'
import type { Severity } from './types'

const ND_FILL = 'rgba(255,255,255,0.14)'
const ND_STROKE = 'rgba(255,255,255,0.26)'

const colorFor = (s: Severity | null): string => getSevColor(s)

type Props = {
  avg: Severity | null
  worst: Severity | null
  tooltip: string
}

/** Two nested hexagons: outer = avg severity, inner = worst-metric severity. */
export default function SeverityHex({ avg, worst, tooltip }: Props) {
  const avgHasData = avg !== null
  const worstHasData = worst !== null
  const cAvg = colorFor(avg)
  const cWorst = colorFor(worst)

  return (
    <div style={{ display: 'grid', placeItems: 'center', gap: 4 }} title={tooltip}>
      <svg width="28" height="30" viewBox="0 0 28 30" style={{ display: 'block' }} aria-label={tooltip}>
        <title>{tooltip}</title>
        {/* avg (outer) */}
        <polygon
          points="14,2 26,8 26,22 14,28 2,22 2,8"
          fill={avgHasData ? cAvg : ND_FILL}
          opacity={avgHasData ? 0.22 : 0.38}
          stroke={avgHasData ? cAvg : ND_STROKE}
          strokeWidth="1"
        />
        {/* worst (inner) */}
        <polygon
          points="14,6 22,10 22,20 14,24 6,20 6,10"
          fill={worstHasData ? cWorst : ND_FILL}
          opacity={worstHasData ? 0.50 : 0.35}
          stroke={worstHasData ? cWorst : ND_STROKE}
          strokeWidth="1.2"
        />
      </svg>
    </div>
  )
}